/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtNldc.id.label': '主键',
'tqtNldc.id.holder': '请输入主键',
'tqtNldc.id.max': '主键最多11个字符',
'tqtNldc.id.required': '主键必填',
'tqtNldc.searchId.holder': '搜索主键',
'tqtNldc.companyCode.label': '统一社会信用代码',
'tqtNldc.companyCode.holder': '请输入统一社会信用代码',
'tqtNldc.companyCode.max': '统一社会信用代码最多18个字符',
'tqtNldc.companyCode.required': '统一社会信用代码必填',
'tqtNldc.searchCompanyCode.holder': '搜索统一社会信用代码',
'tqtNldc.isAbnormal.label': '是否有异常（0有异常，1无异常）',
'tqtNldc.isAbnormal.holder': '请输入是否有异常（0有异常，1无异常）',
'tqtNldc.isAbnormal.max': '是否有异常（0有异常，1无异常）最多1个字符',
'tqtNldc.isAbnormal.required': '是否有异常（0有异常，1无异常）必填',
'tqtNldc.searchIsAbnormal.holder': '搜索是否有异常（0有异常，1无异常）',
'tqtNldc.inspectionTime.label': '督查时间(填报时间)',
'tqtNldc.inspectionTime.holder': '请输入督查时间(填报时间)',
'tqtNldc.inspectionTime.max': '督查时间(填报时间)最多null个字符',
'tqtNldc.inspectionTime.required': '督查时间(填报时间)必填',
'tqtNldc.searchInspectionTime.holder': '搜索督查时间(填报时间)',
'tqtNldc.createTime.label': '创建时间',
'tqtNldc.createTime.holder': '请输入创建时间',
'tqtNldc.createTime.max': '创建时间最多null个字符',
'tqtNldc.createTime.required': '创建时间必填',
'tqtNldc.searchCreateTime.holder': '搜索创建时间',
'tqtNldc.jkhwWsbJzxh.label': '进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbJzxh.holder': '请输入进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbJzxh.max': '进口货物未申报-集装箱号最多255个字符',
'tqtNldc.jkhwWsbJzxh.required': '进口货物未申报-集装箱号必填',
'tqtNldc.searchJkhwWsbJzxh.holder': '搜索进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbBgdh.label': '进口货物未申报-报关单号',
'tqtNldc.jkhwWsbBgdh.holder': '请输入进口货物未申报-报关单号',
'tqtNldc.jkhwWsbBgdh.max': '进口货物未申报-报关单号最多255个字符',
'tqtNldc.jkhwWsbBgdh.required': '进口货物未申报-报关单号必填',
'tqtNldc.searchJkhwWsbBgdh.holder': '搜索进口货物未申报-报关单号',
'tqtNldc.jkhwWjcBgdh.label': '进口货物未检测-报关单号',
'tqtNldc.jkhwWjcBgdh.holder': '请输入进口货物未检测-报关单号',
'tqtNldc.jkhwWjcBgdh.max': '进口货物未检测-报关单号最多255个字符',
'tqtNldc.jkhwWjcBgdh.required': '进口货物未检测-报关单号必填',
'tqtNldc.searchJkhwWjcBgdh.holder': '搜索进口货物未检测-报关单号',
'tqtNldc.jkhwWjcJzxh.label': '进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWjcJzxh.holder': '请输入进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWjcJzxh.max': '进口货物未检测-集装箱号  最多255个字符',
'tqtNldc.jkhwWjcJzxh.required': '进口货物未检测-集装箱号  必填',
'tqtNldc.searchJkhwWjcJzxh.holder': '搜索进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWxdJzxh.label': '进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdJzxh.holder': '请输入进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdJzxh.max': '进口货物未消毒-集装箱号最多255个字符',
'tqtNldc.jkhwWxdJzxh.required': '进口货物未消毒-集装箱号必填',
'tqtNldc.searchJkhwWxdJzxh.holder': '搜索进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdBgdh.label': '进口货物未消毒-报关单号',
'tqtNldc.jkhwWxdBgdh.holder': '请输入进口货物未消毒-报关单号',
'tqtNldc.jkhwWxdBgdh.max': '进口货物未消毒-报关单号最多255个字符',
'tqtNldc.jkhwWxdBgdh.required': '进口货物未消毒-报关单号必填',
'tqtNldc.searchJkhwWxdBgdh.holder': '搜索进口货物未消毒-报关单号',
'tqtNldc.userId.label': '填报员用户id',
'tqtNldc.userId.holder': '请输入填报员用户id',
'tqtNldc.userId.max': '填报员用户id最多11个字符',
'tqtNldc.userId.required': '填报员用户id必填',
'tqtNldc.searchUserId.holder': '搜索填报员用户id',
},
'zh-TW': {
'tqtNldc.id.label': '主键',
'tqtNldc.id.holder': '請輸入主键',
'tqtNldc.id.max': '主键最多11個字符',
'tqtNldc.id.required': '主键必填',
'tqtNldc.searchId.holder': '搜索主键',
'tqtNldc.companyCode.label': '统一社会信用代码',
'tqtNldc.companyCode.holder': '請輸入统一社会信用代码',
'tqtNldc.companyCode.max': '统一社会信用代码最多18個字符',
'tqtNldc.companyCode.required': '统一社会信用代码必填',
'tqtNldc.searchCompanyCode.holder': '搜索统一社会信用代码',
'tqtNldc.isAbnormal.label': '是否有异常（0有异常，1无异常）',
'tqtNldc.isAbnormal.holder': '請輸入是否有异常（0有异常，1无异常）',
'tqtNldc.isAbnormal.max': '是否有异常（0有异常，1无异常）最多1個字符',
'tqtNldc.isAbnormal.required': '是否有异常（0有异常，1无异常）必填',
'tqtNldc.searchIsAbnormal.holder': '搜索是否有异常（0有异常，1无异常）',
'tqtNldc.inspectionTime.label': '督查时间(填报时间)',
'tqtNldc.inspectionTime.holder': '請輸入督查时间(填报时间)',
'tqtNldc.inspectionTime.max': '督查时间(填报时间)最多null個字符',
'tqtNldc.inspectionTime.required': '督查时间(填报时间)必填',
'tqtNldc.searchInspectionTime.holder': '搜索督查时间(填报时间)',
'tqtNldc.createTime.label': '创建时间',
'tqtNldc.createTime.holder': '請輸入创建时间',
'tqtNldc.createTime.max': '创建时间最多null個字符',
'tqtNldc.createTime.required': '创建时间必填',
'tqtNldc.searchCreateTime.holder': '搜索创建时间',
'tqtNldc.jkhwWsbJzxh.label': '进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbJzxh.holder': '請輸入进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbJzxh.max': '进口货物未申报-集装箱号最多255個字符',
'tqtNldc.jkhwWsbJzxh.required': '进口货物未申报-集装箱号必填',
'tqtNldc.searchJkhwWsbJzxh.holder': '搜索进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbBgdh.label': '进口货物未申报-报关单号',
'tqtNldc.jkhwWsbBgdh.holder': '請輸入进口货物未申报-报关单号',
'tqtNldc.jkhwWsbBgdh.max': '进口货物未申报-报关单号最多255個字符',
'tqtNldc.jkhwWsbBgdh.required': '进口货物未申报-报关单号必填',
'tqtNldc.searchJkhwWsbBgdh.holder': '搜索进口货物未申报-报关单号',
'tqtNldc.jkhwWjcBgdh.label': '进口货物未检测-报关单号',
'tqtNldc.jkhwWjcBgdh.holder': '請輸入进口货物未检测-报关单号',
'tqtNldc.jkhwWjcBgdh.max': '进口货物未检测-报关单号最多255個字符',
'tqtNldc.jkhwWjcBgdh.required': '进口货物未检测-报关单号必填',
'tqtNldc.searchJkhwWjcBgdh.holder': '搜索进口货物未检测-报关单号',
'tqtNldc.jkhwWjcJzxh.label': '进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWjcJzxh.holder': '請輸入进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWjcJzxh.max': '进口货物未检测-集装箱号  最多255個字符',
'tqtNldc.jkhwWjcJzxh.required': '进口货物未检测-集装箱号  必填',
'tqtNldc.searchJkhwWjcJzxh.holder': '搜索进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWxdJzxh.label': '进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdJzxh.holder': '請輸入进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdJzxh.max': '进口货物未消毒-集装箱号最多255個字符',
'tqtNldc.jkhwWxdJzxh.required': '进口货物未消毒-集装箱号必填',
'tqtNldc.searchJkhwWxdJzxh.holder': '搜索进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdBgdh.label': '进口货物未消毒-报关单号',
'tqtNldc.jkhwWxdBgdh.holder': '請輸入进口货物未消毒-报关单号',
'tqtNldc.jkhwWxdBgdh.max': '进口货物未消毒-报关单号最多255個字符',
'tqtNldc.jkhwWxdBgdh.required': '进口货物未消毒-报关单号必填',
'tqtNldc.searchJkhwWxdBgdh.holder': '搜索进口货物未消毒-报关单号',
'tqtNldc.userId.label': '填报员用户id',
'tqtNldc.userId.holder': '請輸入填报员用户id',
'tqtNldc.userId.max': '填报员用户id最多11個字符',
'tqtNldc.userId.required': '填报员用户id必填',
'tqtNldc.searchUserId.holder': '搜索填报员用户id',
},
'en-US': {
'tqtNldc.id.label': '主键',
'tqtNldc.id.holder': 'Enter 主键',
'tqtNldc.id.max': '主键 max length: 11',
'tqtNldc.id.required': '主键 required',
'tqtNldc.searchId.holder': 'Search 主键',
'tqtNldc.companyCode.label': '统一社会信用代码',
'tqtNldc.companyCode.holder': 'Enter 统一社会信用代码',
'tqtNldc.companyCode.max': '统一社会信用代码 max length: 18',
'tqtNldc.companyCode.required': '统一社会信用代码 required',
'tqtNldc.searchCompanyCode.holder': 'Search 统一社会信用代码',
'tqtNldc.isAbnormal.label': '是否有异常（0有异常，1无异常）',
'tqtNldc.isAbnormal.holder': 'Enter 是否有异常（0有异常，1无异常）',
'tqtNldc.isAbnormal.max': '是否有异常（0有异常，1无异常） max length: 1',
'tqtNldc.isAbnormal.required': '是否有异常（0有异常，1无异常） required',
'tqtNldc.searchIsAbnormal.holder': 'Search 是否有异常（0有异常，1无异常）',
'tqtNldc.inspectionTime.label': '督查时间(填报时间)',
'tqtNldc.inspectionTime.holder': 'Enter 督查时间(填报时间)',
'tqtNldc.inspectionTime.max': '督查时间(填报时间) max length: null',
'tqtNldc.inspectionTime.required': '督查时间(填报时间) required',
'tqtNldc.searchInspectionTime.holder': 'Search 督查时间(填报时间)',
'tqtNldc.createTime.label': '创建时间',
'tqtNldc.createTime.holder': 'Enter 创建时间',
'tqtNldc.createTime.max': '创建时间 max length: null',
'tqtNldc.createTime.required': '创建时间 required',
'tqtNldc.searchCreateTime.holder': 'Search 创建时间',
'tqtNldc.jkhwWsbJzxh.label': '进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbJzxh.holder': 'Enter 进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbJzxh.max': '进口货物未申报-集装箱号 max length: 255',
'tqtNldc.jkhwWsbJzxh.required': '进口货物未申报-集装箱号 required',
'tqtNldc.searchJkhwWsbJzxh.holder': 'Search 进口货物未申报-集装箱号',
'tqtNldc.jkhwWsbBgdh.label': '进口货物未申报-报关单号',
'tqtNldc.jkhwWsbBgdh.holder': 'Enter 进口货物未申报-报关单号',
'tqtNldc.jkhwWsbBgdh.max': '进口货物未申报-报关单号 max length: 255',
'tqtNldc.jkhwWsbBgdh.required': '进口货物未申报-报关单号 required',
'tqtNldc.searchJkhwWsbBgdh.holder': 'Search 进口货物未申报-报关单号',
'tqtNldc.jkhwWjcBgdh.label': '进口货物未检测-报关单号',
'tqtNldc.jkhwWjcBgdh.holder': 'Enter 进口货物未检测-报关单号',
'tqtNldc.jkhwWjcBgdh.max': '进口货物未检测-报关单号 max length: 255',
'tqtNldc.jkhwWjcBgdh.required': '进口货物未检测-报关单号 required',
'tqtNldc.searchJkhwWjcBgdh.holder': 'Search 进口货物未检测-报关单号',
'tqtNldc.jkhwWjcJzxh.label': '进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWjcJzxh.holder': 'Enter 进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWjcJzxh.max': '进口货物未检测-集装箱号   max length: 255',
'tqtNldc.jkhwWjcJzxh.required': '进口货物未检测-集装箱号   required',
'tqtNldc.searchJkhwWjcJzxh.holder': 'Search 进口货物未检测-集装箱号  ',
'tqtNldc.jkhwWxdJzxh.label': '进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdJzxh.holder': 'Enter 进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdJzxh.max': '进口货物未消毒-集装箱号 max length: 255',
'tqtNldc.jkhwWxdJzxh.required': '进口货物未消毒-集装箱号 required',
'tqtNldc.searchJkhwWxdJzxh.holder': 'Search 进口货物未消毒-集装箱号',
'tqtNldc.jkhwWxdBgdh.label': '进口货物未消毒-报关单号',
'tqtNldc.jkhwWxdBgdh.holder': 'Enter 进口货物未消毒-报关单号',
'tqtNldc.jkhwWxdBgdh.max': '进口货物未消毒-报关单号 max length: 255',
'tqtNldc.jkhwWxdBgdh.required': '进口货物未消毒-报关单号 required',
'tqtNldc.searchJkhwWxdBgdh.holder': 'Search 进口货物未消毒-报关单号',
'tqtNldc.userId.label': '填报员用户id',
'tqtNldc.userId.holder': 'Enter 填报员用户id',
'tqtNldc.userId.max': '填报员用户id max length: 11',
'tqtNldc.userId.required': '填报员用户id required',
'tqtNldc.searchUserId.holder': 'Search 填报员用户id',
}
};